/* Copyright 2018 The Mathworks, Inc. */

define([], function () {
  // Do not add items without additional "filtering code"

  // https://github.com/leizongmin/js-xss/blob/master/dist/xss.js#L12
  // + Style
  let whiteListJava = {
    A: ['target', 'href', 'title'],
    ABBR: ['title'],
    ADDRESS: [],
    AREA: ['shape', 'coords', 'href', 'alt'],
    ARTICLE: [],
    ASIDE: [],
    AUDIO: ['autoplay', 'controls', 'loop', 'preload', 'src'],
    B: [],
    BDI: ['dir'],
    BDO: ['dir'],
    BIG: [],
    BLOCKQUOTE: ['cite'],
    BR: [],
    CAPTION: [],
    CENTER: [],
    CITE: [],
    CODE: [],
    COL: ['align', 'valign', 'span', 'width'],
    COLGROUP: ['align', 'valign', 'span', 'width'],
    DD: [],
    DEL: ['datetime'],
    DETAILS: ['open'],
    DIV: [],
    DL: [],
    DT: [],
    EM: [],
    FONT: ['color', 'size', 'face'],
    FOOTER: [],
    H1: [],
    H2: [],
    H3: [],
    H4: [],
    H5: [],
    H6: [],
    HEADER: [],
    HR: [],
    I: [],
    IMG: ['src', 'alt', 'title', 'width', 'height'],
    INS: ['datetime'],
    LI: [],
    MARK: [],
    NAV: [],
    OL: [],
    P: [],
    PRE: [],
    S: [],
    SECTION: [],
    SMALL: [],
    SPAN: [],
    SUB: [],
    SUP: [],
    STRONG: [],
    TABLE: ['width', 'border', 'align', 'valign'],
    TBODY: ['align', 'valign'],
    TD: ['width', 'rowspan', 'colspan', 'align', 'valign'],
    TFOOT: ['align', 'valign'],
    TH: ['width', 'rowspan', 'colspan', 'align', 'valign'],
    THEAD: ['align', 'valign'],
    TR: ['rowspan', 'align', 'valign'],
    TT: [],
    U: [],
    UL: [],
    VIDEO: ['autoplay', 'controls', 'loop', 'preload', 'src', 'height', 'width']
  };

  const protocolAttrsWhiteListJava = {
    href: {
      'http:': true,
      'https:': true,
      'mailto:': true,
      'matlab:': true,
      relative: {
        '#': true,
        '/': true
      }
    },
    src: {
      'http:': true,
      'https:': true,
      'mailto:': true,
      relative: {
        '#': true,
        '/': true
      }
    }
  };

  // Pull out uncommon styles or styles that support:
  // Urls as options
  // Also pull out styles that would generally allow:
  // Clickjacking attacks
  const whiteListStyles = [
    'backgroundColor',
    'borderBottom',
    'borderBottomColor',
    'borderBottomLeftRadius',
    'borderBottomRightRadius',
    'borderBottomStyle',
    'borderBottomWidth',
    'borderLeft',
    'borderLeftColor',
    'borderLeftStyle',
    'borderLeftWidth',
    'borderRadius',
    'borderRight',
    'borderRightColor',
    'borderRightStyle',
    'borderRightWidth',
    'borderSpacing',
    'borderStyle',
    'borderTop',
    'borderTopColor',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderTopStyle',
    'borderTopWidth',
    'borderWidth',
    'color',
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontWeight',
    'height',
    'lineHeight',
    'margin',
    'marginBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'maxHeight',
    'maxWidth',
    'minHeight',
    'minWidth',
    'overflow',
    'overflowWrap',
    'overflowX',
    'overflowY',
    'padding',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'textAlign',
    'textAnchor',
    'textDecoration',
    'textIndent',
    'textOverflow',
    'textShadow',
    'textTransform',
    'width'
  ];

  let copyAndSanitizeStyles = function (cleanNode, dirtyNode) {
    let wasStyleTagSpecified = dirtyNode.getAttribute('style');
    if (cleanNode.style && wasStyleTagSpecified !== null && wasStyleTagSpecified !== '') {
      for (let i = 0; i < whiteListStyles.length; i += 1) {
        let styleKey = whiteListStyles[i];
        let value = dirtyNode.style[styleKey];
        if (cleanNode.style[styleKey] !== undefined) {
          cleanNode.style[styleKey] = value;
        }
      }
    }
  };

  let buildSanitizer = function (whiteList, whitelistProtocols, allowStyleTag) {
    return function (htmlToClean) {
      let cleanUrl = function (whitelistProtocols, dirtyUrl) {
        let dirtyTrimUrl = String.prototype.trim.call(dirtyUrl);
        let locateColon = dirtyTrimUrl.indexOf(':');
        if (locateColon < 0) {
        // Check Relative
          if (whitelistProtocols.relative[dirtyTrimUrl.charAt(0)]) {
            return dirtyTrimUrl;
          }
        }
        let protocol = dirtyTrimUrl.substring(0, locateColon);
        if (whitelistProtocols[protocol + ':']) {
          return dirtyTrimUrl;
        }
        return '#';
      };

      let getCleanAttrs = function (whitelistAttrs, dirtyElem) {
        let cleanAttrs = [];
        for (let attrIndex = 0; attrIndex < whitelistAttrs.length; attrIndex += 1) {
          let attrToCheck = whitelistAttrs[attrIndex];
          if (dirtyElem.hasAttribute(attrToCheck)) {
            let dirtyValue = dirtyElem.getAttribute(attrToCheck);
            let cleanValue = '';
            if (whitelistProtocols[attrToCheck]) {
              cleanValue = cleanUrl(whitelistProtocols[attrToCheck], dirtyValue);
            } else {
              cleanValue = dirtyValue;
            }
            cleanAttrs.push({
              key: attrToCheck,
              value: cleanValue
            });
          }
        }
        return cleanAttrs;
      };

      let getCleanNode = function (dirtyNode) {
        let cleanNode;
        if (dirtyNode.nodeType === window.Node.ELEMENT_NODE) {
          let found = whiteList[dirtyNode.tagName];
          if (found) {
            cleanNode = document.createElement(dirtyNode.tagName);
            let whiteListAttr = whiteList[dirtyNode.tagName];
            let cleanAttr = getCleanAttrs(whiteListAttr, dirtyNode);
            cleanAttr.forEach((item) => {
              cleanNode.setAttribute(item.key, item.value);
            });
            if (allowStyleTag) {
              copyAndSanitizeStyles(cleanNode, dirtyNode);
            }
          } else { // We could potentially "Keep Children", "Replace bad node with div", or "Discard children"
            cleanNode = document.createDocumentFragment();
          }
        } else if (dirtyNode.nodeType === window.Node.TEXT_NODE) {
          cleanNode = document.createTextNode(dirtyNode.textContent);
        } else {
          cleanNode = document.createDocumentFragment();
        }
        return cleanNode;
      };

      let sanitizeDom = function (dirtyRoot, level = 0) {
        let cleanNode = document.createDocumentFragment();
        if (level > 150 || !dirtyRoot) {
          // Keep stack a reasonable size
          // (Firefox Limits DOM 200 levels deep)
          // and don't recurse null nodes
          return cleanNode;
        }
        for (
          let dirtyChild = dirtyRoot.firstChild;
          dirtyChild;
          dirtyChild = dirtyChild.nextSibling
        ) {
          let tmpNode = getCleanNode(dirtyChild);
          if (dirtyChild.nodeType === window.Node.ELEMENT_NODE) {
            tmpNode.appendChild(sanitizeDom(dirtyChild, level + 1));
          }
          cleanNode.appendChild(tmpNode);
        }
        return cleanNode;
      };

      /* eslint-disable */
      let domParser = new DOMParser();
      /* eslint-enable */
      let dirtyDom = domParser.parseFromString(htmlToClean, 'text/html');
      let cleanDom;
      if (dirtyDom.body) {
        cleanDom = sanitizeDom(dirtyDom.body);
      } else {
        cleanDom = document.createDocumentFragment();
      }
      return cleanDom;
    };
  };

  return {
    sanitizeHtmlFromJava: buildSanitizer(whiteListJava, protocolAttrsWhiteListJava, true)
  };
});
